import React from "react";
import { Stack, Dialog, Spinner, SpinnerSize } from "office-ui-fabric-react/lib";

export const Loading = (props:any) => {
  return (
    <Dialog
      hidden={false}
      modalProps={{
        isBlocking: true,
        styles: { main: { maxWidth: 240 } },
        isModeless: props.isModeless ? props.isModeless : false,
      }}
    >
      <Stack>
        <Spinner size={SpinnerSize.large} label="Loading" labelPosition="bottom" />
      </Stack>
    </Dialog>
  );
};

export default {
  Loading: Loading,
};
